import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Progress } from '@/components/ui/progress';
import { Star, ThumbsUp, MessageSquare } from 'lucide-react';

const reviews = [
  { id: 1, customer: 'David Brown', rating: 5, comment: 'Excellent service, very fast transaction!', time: '2 hours ago', helpful: 12 },
  { id: 2, customer: 'Lisa Anderson', rating: 4, comment: 'Good rates, professional service. Would recommend!', time: '5 hours ago', helpful: 8 },
  { id: 3, customer: 'Tom Harris', rating: 5, comment: 'Best forex vendor in Lagos, highly recommended!', time: '1 day ago', helpful: 15 },
  { id: 4, customer: 'Mary Johnson', rating: 5, comment: 'Very trustworthy and reliable. Quick response time.', time: '2 days ago', helpful: 10 },
  { id: 5, customer: 'James Wilson', rating: 4, comment: 'Great experience overall. Rates are competitive.', time: '3 days ago', helpful: 6 },
];

const ratingBreakdown = [
  { stars: 5, count: 89, percentage: 89 },
  { stars: 4, count: 15, percentage: 15 },
  { stars: 3, count: 4, percentage: 4 },
  { stars: 2, count: 2, percentage: 2 },
  { stars: 1, count: 0, percentage: 0 },
];

export default function VendorReviews() {
  const averageRating = 4.8;
  const totalReviews = 110;

  return (
    
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Reviews & Ratings</h1>
          <p className="text-muted-foreground">Manage your customer feedback</p>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {/* Rating Summary */}
          <Card className="lg:col-span-1">
            <CardHeader>
              <CardTitle>Rating Summary</CardTitle>
              <CardDescription>Overview of your ratings</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="text-center">
                <p className="text-5xl font-bold">{averageRating}</p>
                <div className="flex items-center justify-center gap-1 my-2">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star 
                      key={i} 
                      className={`h-5 w-5 ${i < Math.floor(averageRating) ? 'fill-amber-400 text-amber-400' : 'text-muted-foreground'}`} 
                    />
                  ))}
                </div>
                <p className="text-sm text-muted-foreground">Based on {totalReviews} reviews</p>
              </div>

              <div className="space-y-2">
                {ratingBreakdown.map((item) => (
                  <div key={item.stars} className="flex items-center gap-3">
                    <span className="text-sm w-8">{item.stars}★</span>
                    <Progress value={item.percentage} className="flex-1 h-2" />
                    <span className="text-sm text-muted-foreground w-10 text-right">{item.count}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* Recent Reviews */}
          <Card className="lg:col-span-2">
            <CardHeader>
              <CardTitle>Recent Reviews</CardTitle>
              <CardDescription>Latest customer feedback</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {reviews.map((review) => (
                  <div key={review.id} className="p-4 border rounded-lg">
                    <div className="flex items-start justify-between">
                      <div className="flex items-center gap-3">
                        <Avatar className="h-10 w-10">
                          <AvatarFallback className="bg-violet-500/20 text-violet-500">
                            {review.customer.charAt(0)}
                          </AvatarFallback>
                        </Avatar>
                        <div>
                          <p className="font-medium">{review.customer}</p>
                          <div className="flex items-center gap-2">
                            <div className="flex items-center gap-0.5">
                              {Array.from({ length: 5 }).map((_, i) => (
                                <Star 
                                  key={i} 
                                  className={`h-3 w-3 ${i < review.rating ? 'fill-amber-400 text-amber-400' : 'text-muted-foreground'}`} 
                                />
                              ))}
                            </div>
                            <span className="text-xs text-muted-foreground">{review.time}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p className="mt-3 text-sm text-muted-foreground">{review.comment}</p>
                    <div className="flex items-center gap-4 mt-3">
                      <button className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
                        <ThumbsUp className="h-4 w-4" />
                        Helpful ({review.helpful})
                      </button>
                      <button className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
                        <MessageSquare className="h-4 w-4" />
                        Reply
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    
  );
}
